import React from "react";
import PaperBase from "../Paper/PaperBase";
import Typography from "@mui/material/Typography";
import TextEllipsis from "../text/TextEllipsis";
import TextStatusUnitOfLearning from "../text/TextStatus";

const RenderCurriculum = ({ elements, structure = {}, lcs, width }) => {
  const newData = {};
  structure?.children?.map((item) => {
    newData[item._id] = {};
    newData[item._id].elements = {};

    newData[item._id].lcs = lcs.map((lc) => {
      const lcData = lc.curriculumElements?.[structure._id] || {};
      const lcDataElements = elements?.[lc._id];
      if (lcDataElements) {
        const elementsData = lcDataElements?.children.find(
          (item) => item._id === lcData?.value
        );
        if (elementsData) {
          const se = elementsData?.elements?.find(
            (el) => el.elementStructureId === item._id
          );
          if (se) {
            newData[item._id].elements[lc._id] = se;
          }
        }
      }
      return {
        ...lc,
        curriculumElements: {
          [item._id]: lcData?.children ? lcData.children[item._id] : {},
        },
      };
    });
    newData[item._id].structure = item;
  });

  return (
    <>
      {Object.keys(newData)
        .reverse()
        .filter((key) =>
          newData[key].lcs.some(
            (lc) => lc.curriculumElements?.[newData[key].structure._id]?.value
          )
        )
        .map((key) => {
          return (
            <RenderCurriculum
              key={key}
              elements={newData[key].elements}
              structure={newData[key].structure}
              lcs={newData[key].lcs}
              width={width}
            />
          );
        })}
      <div className="flex flex-nowrap w-full gap-1" key={structure?._id}>
        <PaperBase
          backgroundColor={structure?.primaryColor}
          color={structure?.secondaryColor}
          className={["font-bold sticky left-0 z-10", width].join(" ")}
          children={structure?.name}
        />
        {lcs.map((lc, index) => {
          const lcData = lc.curriculumElements?.[structure?._id] || {};
          const lcDataElements = elements?.[lc?._id];
          let elementsData = null;
          if (lcDataElements) {
            elementsData = lcDataElements?.children?.find(
              (item) => item._id === lcData?.value
            );
          }
          return (
            <PaperBase
              key={`structure-${structure._id}-lc-${lc._id}-index-${index}`}
              backgroundColor={structure?.primaryColor}
              color={structure?.secondaryColor}
              className={[
                "min-w-200px w-full text-ellipsis relative",
                lcData?.value ? "" : "bg-lines",
              ].join(" ")}
              children={
                <>
                  <Typography className="text-ellipsis text-sm">
                    {elementsData?.name || lcData?.value}
                  </Typography>
                  {/* <Chip label={`v${lc.version || '1'}`} size='small' color='primary' className='font-bold absolute top-2 right-2'/> */}
                </>
              }
            />
          );
        })}
      </div>
    </>
  );
};

const CurriculumElementsCards = ({
  lcs = [],
  width = "min-w-120px max-w-120px",
  currentCurriculum,
  classUlInfo
}) => {

  const lcsElements = {};
  lcs.forEach((lc) => {
    lcsElements[lc._id] = currentCurriculum.elements;
  });

  return (
    <>
      <RenderCurriculum
        elements={lcsElements}
        structure={currentCurriculum.elementsStructure}
        lcs={lcs || []}
        width={width}
      />
      { classUlInfo ? 
       <div className="flex flex-nowrap w-full gap-1 sticky bottom-0 z-10">
       <PaperBase
         className={[
           "font-bold sticky bottom-1px left-0 z-12 text-primary-foreground bg-primary flex flex-col gap-1",
           width,
         ].join(" ")}
         children="Version"
       >
         <Typography
           variant="inherit"
           children="Version"
           size="small"
         />
         <Typography
           variant="inherit"
           children="Class"
           size="small"
           className="text-lg"
         />
         <Typography
           variant="inherit"
           children="Unit of Learning"
           size="small"
           className="font-bold text-sm"
         />
       </PaperBase>
       {lcs?.map((lc, index) => {
         const clss = lc?.classes?.[0];
         const ul = lc?.developmentalRubrics?.[0];
         return (
           <PaperBase
             key={`lc-elements-version-lc-${lc._id}-ul-${lc.ulId || 'main'}-class-${lc.classId || 'main'}-index-${index}`}
             className={[
               "min-w-200px w-full text-ellipsis text-primary-foreground bg-primary flex flex-col gap-1",
             ].join(" ")}
           >
             <Typography
                 children={`V${lc.version || 1}`}
                 size="small"
                 className="font-bold text-sm"
               />
               <Typography
               variant="inherit"
               children={clss?.code || 'MAIN'}
               size="small"
               className="text-lg"
             />
             {ul ? (
               <TextEllipsis
                 variant="inherit"
                 size="small"
                 className="font-bold text-sm"
               >
                 <TextStatusUnitOfLearning
                   startDate={ul?.startDate}
                   endDate={ul?.endDate}
                 />
                 <span className="font-bold text-sm pl-1">{ul?.name || ''}</span>
               </TextEllipsis>
             ) : <span  className="font-bold text-sm">-</span>}
           </PaperBase>
         );
       })}
     </div> : 
      <div className="flex flex-nowrap w-full gap-1 sticky bottom-0 z-10">
        <PaperBase
          className={[
            "font-bold sticky bottom-1px left-0 z-11 text-primary-foreground bg-primary",
            width,
          ].join(" ")}
          children="Version"
        />
        {lcs?.map((lc, index) => {
          return (
            <PaperBase
              key={`lc-elements-version-lc-${lc._id}-index-${index}`}
              className={[
                "min-w-200px w-full text-ellipsis text-primary-foreground bg-primary",
              ].join(" ")}
              children={
                <Typography
                  children={`V${lc.version || 1}${lc.ulId === '' ? ' (main)' : ''}`}
                  size="small"
                  className="font-bold text-sm"
                />
              }
            />
          );
        })}
      </div>
     }
    </>
  );
};

export default CurriculumElementsCards;
